import { DatePicker } from '@/components/ui/DatePicker'
import { useRouteStore } from '@/store/route'
import moment from 'moment'
import { useCallback } from 'react'
import { FormProvider, useForm } from 'react-hook-form'

const minDate = !import.meta.env.DEV
  ? moment().add(-7, 'days').toDate()
  : undefined

interface DateFormData {
  day: string
}

export const RouteDateSelect = () => {
  const selectedDate = useRouteStore((state) => state.selectedDate)
  const setSelectedDate = useRouteStore((state) => state.setSelectedDate)

  const methods = useForm<DateFormData>({
    defaultValues: {
      day: selectedDate,
    },
  })

  const handleChange = useCallback(
    (value: string) => {
      setSelectedDate(value)
    },
    [setSelectedDate]
  )

  return (
    <FormProvider {...methods}>
      <DatePicker<DateFormData>
        name="day"
        label="Day"
        modalTitle="Select Date"
        onChange={handleChange}
        testId="route-date-select"
        minDate={minDate}
      />
    </FormProvider>
  )
}
